import { render, staticRenderFns } from "./advertisementList.vue?vue&type=template&id=1645a7fb&scoped=true"
import script from "./advertisementList.vue?vue&type=script&lang=js"
export * from "./advertisementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1645a7fb",
  null
  
)

export default component.exports